// extracted by mini-css-extract-plugin
export default {"root":"client__src__components__icon__root"};